import { render } from "./FooterMini.vue?vue&type=template&id=747528c3&scoped=true"
import script from "./FooterMini.vue?vue&type=script&lang=js"
export * from "./FooterMini.vue?vue&type=script&lang=js"

import "./FooterMini.vue?vue&type=style&index=0&id=747528c3&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1621785964/src/bitbucket.org/hotelkey/hotelkeyapp.com-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747528c3"]])

export default __exports__